import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Button, Stack, Text } from '@guestyci/arc';
import { MFA_VERIFY_FACTOR_TYPES } from '../utils/oktaWidgetHelpers';

const FACTOR_LABELS = {
  [MFA_VERIFY_FACTOR_TYPES.WEBAUTHN]: () => t('Use biometric login or security key'),
  [MFA_VERIFY_FACTOR_TYPES.EMAIL]: () => t('Use email authentication'),
  [MFA_VERIFY_FACTOR_TYPES.SMS]: () => t('Use SMS authentication'),
  [MFA_VERIFY_FACTOR_TYPES.GOOGLE_AUTH]: () => t('Use Google Authenticator app'),
};

const VerifyFactorSwitch = ({ factors, onSelect, disabled }) => {
  if (!factors?.length) return null;

  return (
    <Stack spacing={2} className="gst-w-full">
      <Text size="sm" type="secondary" className="gst-text-center">{t('or')}</Text>
      {factors.map(factorType => (
        <Button
          key={factorType}
          type="button"
          variant="secondary"
          className="gst-w-full"
          onClick={() => onSelect(factorType)}
          disabled={disabled}
        >
          {FACTOR_LABELS[factorType]?.() || factorType}
        </Button>
      ))}
    </Stack>
  );
};

export default VerifyFactorSwitch;
